import CloseButton from "@components/core/CloseButton";
import { useSearchBox, useInstantSearch } from "react-instantsearch";

function CatalogSearchBadge({ getInitializedUiState, updatePersonalisedFilters }) {
  const { query } = useSearchBox();
  const { setUiState } = useInstantSearch();

  function clearFilters() {
    const resetedUiState = getInitializedUiState({});
    setUiState(resetedUiState);
    updatePersonalisedFilters("all", "");
  }

  if (!query) return null;

  return (
    <div className="catalog-selected-filter-btn">
      <span className="font-size-sm">
        {query}
      </span>
      <CloseButton onClick={clearFilters} size="sm" variant="ghost-primary" />
    </div>
  );
}

export default CatalogSearchBadge;
